export default __webpack_public_path__ + "static/workshops-c798ef38bcc796674b2510c2b61d388f.png";